import every from 'lodash/every';

export const sequence = b =>
  every(
    b,
    (a, i) => !(a.call ? a() : setTimeout(() => sequence(b.slice(++i)), a))
  );
